import { render, staticRenderFns } from "./DownloadFileButton.vue?vue&type=template&id=0fe7dd4b&"
import script from "./DownloadFileButton.vue?vue&type=script&lang=js&"
export * from "./DownloadFileButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports